export default (sliderId, sliderSettings) => {
  global.$(`#${sliderId}`).ionRangeSlider(sliderSettings);
};
